import { useEffect, useState } from "react";

import { getAccountingChecklist } from "../../api/accounting";
import { useAuth } from "../../context/AuthContext";
import SalonBusinessCpaTopicPage from "./SalonBusinessCpaTopicPage";

const fallbackSections = [
  {
    title: "Documents",
    body: "Gather the core records needed for accounting review.",
    items: ["Bank statements", "Payroll records", "GST/HST filings"],
  },
  {
    title: "Monthly review",
    body: "Keep sales, expenses, and deposits organized each month.",
    items: ["Review sales deposits", "Confirm expense categories", "Flag owner draws"],
  },
];

export default function SalonBusinessCpaChecklist() {
  const { token } = useAuth();
  const [sections, setSections] = useState(fallbackSections);

  useEffect(() => {
    if (!token) return;
    let active = true;
    getAccountingChecklist(token)
      .then((data) => {
        if (!active) return;
        if (Array.isArray(data?.sections) && data.sections.length) {
          setSections(data.sections);
        }
      })
      .catch(() => {});
    return () => {
      active = false;
    };
  }, [token]);

  return (
    <SalonBusinessCpaTopicPage
      title="Accounting checklist"
      description="A simple starter list for the records and review items that keep salon accounting cleaner."
      sections={sections}
    />
  );
}
